module.exports = __webpack_public_path__ + "static/media/ilustra-02.0aa61049.png";